module.exports = __webpack_public_path__ + "img/menu-cont-bg.9a54014d.webp";